import { StreamingXMLParser } from './streaming-xml-parser';
import { XMLParser as FastXMLParser } from 'fast-xml-parser';
export function fastParseXML(text, options) {
  const parser = new FastXMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: '',
    ...options
  });
  const parsedXML = parser.parse(text);
  return parsedXML;
}
export function parseXMLInBatches(text) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const parser = new StreamingXMLParser({
    ...options,
    strict: true
  });
  parser.write(text);
  parser.close();
  return parser.result;
}
//# sourceMappingURL=parse-xml.js.map